const markdownModules = import.meta.glob('../../docs/*.md', { query: '?raw', import: 'default' })
const htmlModules = import.meta.glob('../../docs/*.html', { query: '?raw', import: 'default' })
const docModules = {
    ...markdownModules,
    ...htmlModules,
}
const DOC_ORDER_FIRST = ['staffing-overview', 'technical-roadmap']

function toLabel(name) {
    return name
        .replace(/_/g, ' ')
        .replace(/\b\w/g, c => c.toUpperCase())
}

function toSlug(name) {
    return name.toLowerCase().replace(/_/g, '-')
}

const docs = Object.keys(docModules)
    .map((path) => {
        const filename = path.split('/').pop()?.split('\\').pop() || ''
        const base = filename.replace(/\.(md|html)$/i, '')
        const format = filename.toLowerCase().endsWith('.html') ? 'html' : 'markdown'
        return {
            slug: toSlug(base),
            label: toLabel(base),
            path,
            format,
        }
    })
    .sort((a, b) => {
        const aIndex = DOC_ORDER_FIRST.indexOf(a.slug)
        const bIndex = DOC_ORDER_FIRST.indexOf(b.slug)
        const aPinned = aIndex >= 0
        const bPinned = bIndex >= 0

        if (aPinned && bPinned) return aIndex - bIndex
        if (aPinned) return -1
        if (bPinned) return 1

        return a.label.localeCompare(b.label)
    })

export const DOCUMENTS = docs

export async function loadDocument(slug) {
    const doc = docs.find(d => d.slug === slug)
    if (!doc) return null
    const loader = docModules[doc.path]
    if (!loader) return null
    const content = await loader()
    return { ...doc, content }
}
